import { createContext, useEffect, useState } from "react";
import FamilyHistoryTable from "./FamilyhistoryTable";
import { IcdListType } from "./type";


export type contextType={
    tableData:any[],
    setTableData:(params:any)=>void
    edit:IcdListType|null;
    setEdit:(params:IcdListType | null)=>void
    success:boolean,
    setSuccess:(params:any)=>void
  
 }

 export const FamilyHistoryContext=createContext<contextType|null>(null)

const FamilyHistory = () => {
    const [tableData,setTableData]=useState([])
    const [edit,setEdit]=useState<IcdListType|null>(null)
    const [success,setSuccess]=useState<boolean>(false)
useEffect(()=>{
  return ()=>{
    setTableData([]),
    setEdit(null)
  }
},[])
  return (
    <FamilyHistoryContext.Provider  value={{tableData,setTableData,edit,setEdit,success,setSuccess}}>
       <FamilyHistoryTable/>
    </FamilyHistoryContext.Provider>
  )
}

export default FamilyHistory
